<template>
    <div class="no-products-popup">
        <div class="message">
            <p>No products found.</p>
        </div>
        <!-- Add any additional UI elements or buttons as needed -->
    </div>
</template>
  
<script>
export default {
    name: 'NoProductsPopup',
};
</script>
  
<style scoped>
.no-products-popup {
    /* Style your popup as needed */
    background-color: white;
    padding-bottom: 5%;
    text-align: center;
}

.message {
    /* Style the message text */
    font-size: 25px;
    color: #262c2e;
    font-family: "Karla", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
</style>


  